import { styled } from '@mui/material/styles';
import { Box, Typography } from '@mui/material';

export const Header = styled(Box)`
  display: flex;
  flex-direction: row;
  align-items: center;
  justify-content: center;
  border-bottom: 1px solid #bdbdbd;
  padding: 0px 0px 16px;
  position: relative;

  .title {
    font-family: 'Roboto';
    font-style: normal;
    font-weight: 500;
    font-size: 23px;
    line-height: 29px;
    display: flex;
    align-items: center;
    text-align: center;
    color: #000000;
  }
`;

export const Text = styled(Typography)`
  font-family: 'Roboto';
  font-style: normal;
  font-weight: 700;
  font-size: 14px;
  line-height: 28px;
  display: flex;
  align-items: center;
  letter-spacing: 0.15px;
  color: #000000;

  margin-bottom: 10px;
`;

export const CardUsers = styled(Box)`
  display: flex;
  flex-direction: row;
  justify-content: start;
  align-items: center;
  padding: 10px 0px;
  gap: 10px;
  width: 100%;
  height: 62px;

  border-top: 1px solid #e0e0e0;
  border-radius: 4px;

  cursor: pointer;

  :hover {
    background-color: rgba(0, 0, 0, 0.04);
  }

  .name {
    font-family: 'Roboto';
    font-style: normal;
    font-weight: 700;
    font-size: 16px;
    line-height: 28px;
    display: flex;
    align-items: center;
    letter-spacing: 0.15px;
    color: #000000;
  }
`;
export const CardSign = styled(Box)`
  display: flex;
  padding: 20px;
  align-items: center;
  gap: 20px;
  align-self: stretch;
  height: 114px;
  width: 100%;
  border-radius: 6px;
  border: 1px solid var(--grey-300, #ddd);
  background: var(--white, #fff);
  margin-bottom: 20px;

  .textSign {
    color: var(--black, #000);
    text-align: center;
    font-family: Roboto;
    font-size: 18px;
    font-style: normal;
    font-weight: 500;
    line-height: 32px; /* 177.778% */
    letter-spacing: 0.15px;
  }
`;

export const CardIcp = styled(Box)`
  display: flex;
  padding: 20px;
  align-items: center;
  gap: 20px;
  align-self: stretch;
  height: 150px;
  width: 100%;
  border-radius: 6px;
  border: 1px solid var(--grey-300, #ddd);
  background: var(--white, #fff);

  .textSign {
    color: var(--black, #000);
    text-align: center;
    font-family: Roboto;
    font-size: 18px;
    font-style: normal;
    font-weight: 500;
    line-height: 32px; /* 177.778% */
    letter-spacing: 0.15px;
  }

  .textIcp {
    color: var(--snackbar, #323232);
    font-family: Roboto;
    font-size: 15px;
    font-style: normal;
    font-weight: 400;
    line-height: normal;
    letter-spacing: 0.15px;
  }
`;

export const Div = styled(Box)`
  .add-logo {
    display: flex;
    flex-direction: row;
    justify-content: center;
    align-items: center;
    padding: 8px 10px;
    gap: 10px;
    width: 440px;
    height: 60px;
    border: 1px dashed #bdbdbd;
    border-radius: 6px;
    width: 100%;
    margin-bottom: 20px;

    cursor: pointer;
  }
`;

export const Users = styled(Box)`
  display: flex;
  flex-direction: row;
  justify-content: flex-start;
  align-items: center;
  padding: 10px 0px;
  gap: 15px;

  width: 100%;
  height: 62px;

  border-bottom: 1px solid #e0e0e0;
  border-radius: 4px;

  cursor: pointer;

  :hover {
    background-color: rgba(0, 0, 0, 0.04);
  }

  .name {
    font-family: 'Roboto';
    font-style: normal;
    font-weight: 700;
    font-size: 16px;
    line-height: 28px;
    display: flex;
    align-items: center;
    letter-spacing: 0.15px;
    color: #000000;
  }
`;

export const SelectedAllBtn = styled(Box)`
  display: flex;
  align-items: center;
  gap: 15px;
  height: 42px;
  border-bottom: 1px solid #e0e0e0;
  margin-top: 5px;

  cursor: pointer;

  :hover {
    background-color: rgba(0, 0, 0, 0.04);
  }
`;

export const TextBtn = styled(Typography)`
  font-family: Roboto;
  font-size: 16px;
  font-style: normal;
  font-weight: 400;
  line-height: 24px;
  letter-spacing: 0.15px;
`;

export const MinuteText = styled(Typography)`
  font-family: 'Roboto';
  font-style: normal;
  font-weight: 700;
  font-size: 16px;
  line-height: 28px;
  display: flex;
  align-items: center;
  letter-spacing: 0.15px;
  color: #212121;
`;

export const ContainerSuccess = styled(Box)`
  display: flex;
  align-items: center;
  gap: 10px;

  .title {
    font-family: 'Roboto';
    font-style: normal;
    font-weight: 700;
    font-size: 24px;
    line-height: 29px;

    display: flex;
    align-items: center;
    text-align: center;
    color: #4caf50;
  }

  .desc {
    font-family: 'Roboto';
    font-style: normal;
    font-weight: 700;
    font-size: 16px;
    line-height: 28px;
    display: flex;
    align-items: center;
    text-align: center;
    letter-spacing: 0.15px;
    color: #212121;
  }
`;

export const Container = styled(Box)`
  height: 675px;

  @media (max-height: 859px) {
    height: 550px;
  }

  @media (max-height: 722px) {
    height: 450px;
  }

  @media (max-height: 639px) {
    height: 350px;
  }

  @media (max-height: 525px) {
    height: 250px;
  }
`;
